import React from "react"
import Nav from "../Components/Outlets/Nav"
import Footer from "../Components/Outlets/Footer"
import { Link } from "react-router-dom"

const programs = [
	{
		icon: "🎓",
		title: "Integrated +1 & +2 Education",
		items: [
			"Science & Commerce streams",
			"Strong academic foundation",
			"Board exam excellence"
		]
	},
	{
		icon: "📚",
		title: "Entrance Coaching (Integrated Model)",
		items: [
			"NEET preparation",
			"JEE (Main & Advanced)",
			"KEAM coaching",
			"CUET preparation",
			"Other national-level exams",
			"Regular testing and mentoring"
		]
	},
	{
		icon: "💼",
		title: "Professional Pathways",
		items: [
			"CA Foundation preparation",
			"Commerce & business career tracks",
			"Early professional field exposure"
		]
	},
	{
		icon: "🌍",
		title: "Global University Pathways",
		items: [
			"International admissions counseling",
			"Scholarship guidance",
			"Personality & profile development"
		]
	},
	{
		icon: "🤖",
		title: "AI & Future Skills",
		items: [
			"Artificial Intelligence programs",
			"Leadership & innovation training",
			"Digital and career-ready skills"
		]
	}
]

const Acadamics = () => {
	return (
		<div>
			<Nav />
			<div className="about-page-main">
				<div className="path-menus acadamics-page">
					<div className="container-main">
						<h2 className="page-heading-name mb-0">Programs</h2>
					</div>
				</div>
			</div>
			<div className="acadamics-page-box">
				<div className="container-main">
					<div className="row">
						<div className="col-lg-12 text-center mb-5">
							<h2 className="chairman-text" style={{ display: "inline-block" }}>Career-Integrated Programs</h2>
							<p className="text-about-sub text-center" style={{ maxWidth: "700px", margin: "0 auto" }}>
								Structured education pathways designed to take you from +1 to a global career&mdash;all under one roof, exclusively for girls.
							</p>
						</div>
						{programs.map((prog, idx) => (
							<div className="col-lg-6 col-md-6 mb-4" key={idx}>
								<div className="program-detail-card">
									<div className="program-detail-icon">{prog.icon}</div>
									<h4 className="program-detail-title">{prog.title}</h4>
									<ul className="program-detail-list">
										{prog.items.map((item, i) => (
											<li key={i}><i className="ri-check-line"></i> {item}</li>
										))}
									</ul>
								</div>
							</div>
						))}
					</div>

					<div className="admission-process-section">
						<div className="row">
							<div className="col-lg-12 text-center mb-4">
								<h2 className="chairman-text" style={{ display: "inline-block" }}>Admission Process</h2>
								<p className="text-about-sub text-center">Build your future with confidence and clarity.</p>
							</div>
							<div className="col-lg-4 col-md-4 mb-4">
								<div className="admission-step-card">
									<div className="step-number">1</div>
									<h5>Application Submission</h5>
									<p>Fill and submit your admission application form online or in person.</p>
								</div>
							</div>
							<div className="col-lg-4 col-md-4 mb-4">
								<div className="admission-step-card">
									<div className="step-number">2</div>
									<h5>Counseling &amp; Interaction</h5>
									<p>Meet our team for a counseling session and academic interaction.</p>
								</div>
							</div>
							<div className="col-lg-4 col-md-4 mb-4">
								<div className="admission-step-card">
									<div className="step-number">3</div>
									<h5>Admission Confirmation</h5>
									<p>Complete the joining formalities and confirm your seat at Le Fille.</p>
								</div>
							</div>
							<div className="col-lg-12 text-center mt-3 mb-5">
								<Link className="btn enquire-btn" to="/admission">Apply Now</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	)
}

export default Acadamics
